export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_02.375a18a7.png";